var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg64 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  rx: 32,
  fill: "#00A4EA"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27.244 46.152c-1.145 0-.95-.432-1.345-1.521L22.535 33.56l25.896-15.363",
  fill: "#C8DAEA"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.245 46.152c.883 0 1.273-.404 1.766-.883l4.708-4.578-5.873-3.542",
  fill: "#A9C9DD"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.843 37.151l14.231 10.514c1.624.896 2.796.432 3.2-1.507l5.793-27.298c.593-2.377-.906-3.456-2.46-2.75L14.593 29.224c-2.322.931-2.308 2.227-.424 2.804l8.73 2.725 20.208-12.75c.954-.578 1.83-.267 1.11.37",
  fill: "url(#64_svg__paint0_linear_5282_7287)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "64_svg__paint0_linear_5282_7287",
  x1: 38.144,
  y1: 29.971,
  x2: 43.655,
  y2: 42.527,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EFF7FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})))));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0IiByeD0iMzIiIGZpbGw9IiMwMEE0RUEiLz4KPHBhdGggZD0iTTI3LjI0MzUgNDYuMTUyNEMyNi4wOTkzIDQ2LjE1MjQgMjYuMjkzOSA0NS43MjA0IDI1Ljg5OTIgNDQuNjMxTDIyLjUzNTIgMzMuNTU5N0w0OC40MzA5IDE4LjE5NjgiIGZpbGw9IiNDOERBRUEiLz4KPHBhdGggZD0iTTI3LjI0NTEgNDYuMTUyQzI4LjEyNzkgNDYuMTUyIDI4LjUxNzggNDUuNzQ4MyAyOS4wMTA3IDQ1LjI2OTJMMzMuNzE5IDQwLjY5MDlMMjcuODQ2IDM3LjE0OTQiIGZpbGw9IiNBOUM5REQiLz4KPHBhdGggZD0iTTI3Ljg0MzIgMzcuMTUxM0w0Mi4wNzQxIDQ3LjY2NTNDNDMuNjk4MiA0OC41NjEzIDQ0Ljg3IDQ4LjA5NzMgNDUuMjc0NiA0Ni4xNTc3TDUxLjA2NzMgMTguODYwNEM1MS42NjAyIDE2LjQ4MjcgNTAuMTYwOSAxNS40MDM5IDQ4LjYwNzIgMTYuMTA5M0wxNC41OTI2IDI5LjIyNTJDMTIuMjcwOCAzMC4xNTY1IDEyLjI4NDYgMzEuNDUxOSAxNC4xNjk0IDMyLjAyOUwyMi44OTgzIDM0Ljc1MzZMNDMuMTA2NyAyMi4wMDQ0QzQ0LjA2MDcgMjEuNDI1OSA0NC45MzY1IDIxLjczNjYgNDQuMjE3OSAyMi4zNzQ2IiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfNTI4Ml83Mjg3KSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzUyODJfNzI4NyIgeDE9IjM4LjE0MzgiIHkxPSIyOS45NzEiIHgyPSI0My42NTQ3IiB5Mj0iNDIuNTI3MiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjRUZGN0ZDIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0id2hpdGUiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
export { Svg64 as ReactComponent };